import React, { Fragment } from 'react'

const UpdateServiceTooltip = () => {
  return (
    <Fragment>
      <p>Location’s Update Service type and number of services.</p>
      <p>If a date is displayed, you have elected to start service on that date.</p>
    </Fragment>
  )
}

export default UpdateServiceTooltip
